import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from './loader/loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(public router: Router, private loaderService: LoaderService) {}

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {

        this.showLoader();

        const idToken = localStorage.getItem("id_token");
        console.log('id_token: ', idToken);

        if (idToken) {
            const cloned = req.clone({
                headers: req.headers.set("Authorization",
                    "Bearer " + idToken)
            });

            return next.handle(cloned).do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response if you want
                    this.onEnd();
                }
            }, (err: any) => {
                this.onEnd();
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        this.router.navigateByUrl('/login');
                    }
                }
            });

        }
        else {
            this.router.navigateByUrl('/login');
            return next.handle(req);
        }
    }

    private onEnd(): void {
        this.hideLoader();
      }
    
      private showLoader(): void {
        this.loaderService.show();
      }
    
      private hideLoader(): void {
        this.loaderService.hide();
      }
}


// WEBPACK FOOTER //
// ./src/app/routes/auth/auth.interceptor.ts